import {Expose, Type} from 'class-transformer';
import {EntityTypes} from "web-shared";

export class GraphNodeModel {
  constructor(init?: Partial<GraphNodeModel>) {
    Object.assign(this, init);
  }
  @Expose({name: 'Label'})
  label: string;
  @Expose({name: 'Type'})
  type: number;
  @Expose({name: 'Id'})
  id: string;
  @Expose({name: 'EntityId'})
  entityId: string;
  @Type(() => GraphNodeDataModel)
  Data: GraphNodeDataModel;
  Color: string;
  TextColor: string;
  StrokeColor: string;
  StrokeWidth: number;

  isMasterInputInstructionNode(): boolean {
    return this.type === EntityTypes.MasterInputInstruction;
  }

  isMasterUseInstructionNode(): boolean {
    return this.type === EntityTypes.MasterUseInstruction;
  }

  isMasterOutputInstructionNode(): boolean {
    return this.type === EntityTypes.MasterOutputInstruction;
  }

  isItemNode(): boolean {
    return this.type === EntityTypes.Item || this.type === EntityTypes.MasterOutputInstruction || this.type === EntityTypes.Material || this.type === EntityTypes.IntermediateItem;
  }

  isMaterialNode(): boolean {
    return this.type === EntityTypes.Material;
  }

  isItemGroupNode(): boolean {
    return this.type === EntityTypes.ItemGroup;
  }

  isProcessSelectorNode(): boolean {
    return this.type === EntityTypes.ProcessSelector;
  }

  isTaskSelectorNode(): boolean {
    return this.type === EntityTypes.TaskSelector;
  }
}

export class GraphNodeDataModel {
  ItemId?: string;
  ItemGroupId?: string;
  ResourceId?: string;
  Specs: Map<string, any>;
}

